<!-- <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="virtualSensor-modal">
    <div style="background-color: #548235;  height: 7px;"></div>
    <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">
        <h5 style="color: rgb(10, 10, 10); text-transform: none;">Virtual Sensor: {{ (sensor.name == '' || sensor.name == undefined) ? sensor.uuid : sensor.name }}</h5>
    </div>

    <div class="modal-body" style="padding: 20px;"> -->
        <div style="margin-bottom: 20px; display: flex; gap: 20px; font-size: 15px;">

            <div class="form-group">
                <label for="CalFreqGroup" style="font-weight: 500;">Frequency </label>
                <span style="font-size: 14px;"> (Calculate new readings every)</span>
                <div style="font-size: 14px;">
                    <input type="radio" [(ngModel)]="virtualSensor.calculateFreq" (ngModelChange)="onCalculateFreqChange()" name="CalFreqGroup" [value]="30" />
                    <label style="padding-left: 5px; padding-right: 20px;">30 Mins</label>
                    <input type="radio" [(ngModel)]="virtualSensor.calculateFreq" (ngModelChange)="onCalculateFreqChange()" name="CalFreqGroup" [value]="60" />
                    <label style="padding-left: 5px; padding-right: 20px;">1 Hr</label>
                    <input type="radio" [(ngModel)]="virtualSensor.calculateFreq" (ngModelChange)="onCalculateFreqChange()" name="CalFreqGroup" [value]="240" />
                    <label style="padding-left: 5px; padding-right: 20px;">4 Hrs</label>
                    <input type="radio" [(ngModel)]="virtualSensor.calculateFreq" (ngModelChange)="onCalculateFreqChange()" name="CalFreqGroup" [value]="480" />
                    <label style="padding-left: 5px; padding-right: 20px;">8 Hrs</label>
                    <input type="radio" [(ngModel)]="virtualSensor.calculateFreq" (ngModelChange)="onCalculateFreqChange()" name="CalFreqGroup" [value]="1440" />
                    <label style="padding-left: 5px;">Daily (UTC) &#64; </label>
                    <select [(ngModel)]="virtualSensor.calculateHourOfDay" name="CalcHourOfDay" [ngModelOptions]="{standalone: true}" style="height: 28px; font-size: 14px; padding: 2px 4px;">
                        <option *ngFor="let h of hourOfDayOptions" [ngValue]="h">{{ h }}</option>
                    </select>
                    <label style="padding-left: 5px; padding-right: 10px;">hr of day</label>
                    <select [(ngModel)]="virtualSensor.calculateMinuteOfHour" name="CalcMinuteOfHour" [ngModelOptions]="{standalone: true}" style="height: 28px; font-size: 14px; padding: 2px 4px;">
                        <option *ngFor="let m of minuteOfHourOptions" [ngValue]="m">{{ m }}</option>
                    </select>
                    <label style="padding-left: 5px; padding-right: 25px;">min</label>
                </div>
            </div>

            <div class="form-group">
                <label style="font-weight: 500;">Delay Calculating For</label>
                <div>
                    <select [(ngModel)]="virtualSensor.calculateDelay" name="CalcDelayGroup" [ngModelOptions]="{standalone: true}" style="height: 28px; font-size: 14px; padding: 2px 4px;">
                        <option *ngFor="let opt of validDelayOptions" [ngValue]="opt.value">{{ opt.name }}</option>
                    </select>
                </div>
            </div>

            <div class="form-group" style="width: 70px; text-align: center; margin-left: auto;">
                <label for="description" style="font-weight: 500;">Enabled</label>
                    <p-toggleswitch id="enabled" [ngModel]="!virtualSensor.isDisabled" (ngModelChange)="virtualSensor.isDisabled = !$event" [ngModelOptions]="{standalone: true}" (onChange)="onVirtulSensorEnable($event)" required>
                </p-toggleswitch>
            </div>
        </div>

        <div class="card" style="margin-bottom: 20px; font-size: 15px;">
            <div style="background-color: #203864; color: white; font-size: 16px; padding-left: 10px; padding-top: 3px; height: 30px;">
                Virtual Functions and Associated Reading Types
            </div>
            <div class="card-body" style="padding-bottom: 10px;">
                <div *ngFor="let function of virtualSensor.functions; let i = index; let firstel = first; let lastel = last ">
                    <div style="margin-bottom: 5px; display: flex; gap: 10px;">
                        <div class="form-group" style="width: 500px;">
                            <div *ngIf="i==0" style="display: flex; gap: 20px;">
                                <label for="{{'VSensorConfig' + i}}" style="font-weight: 500;">Equation(s)</label>
                                <a href="http://mathparser.org/mxparser-math-collection/" style="font-size: 12px;" target="_blank" > <i class="fa-light fa-circle-info"> </i>math options</a>
                            </div>
                            <textarea [(ngModel)]="function.equation" style="width: 500px; height: 38px;" type="text" id="{{'VSensorConfig' + i}}" name="{{'VSensorConfig' + i}}" ></textarea>
                        </div>
            
                        <div class="form-group" style="width: 250px;">
                            <label *ngIf="i==0" for="{{'VSensorReadingType' + i}}" style="font-weight: 500; margin-bottom: 2px;">Reading Type</label>
                            <input type="text" name="{{'VSensorReadingType' + i}}" list="vSensorReadingTypes" class="form-control" [(ngModel)]="function.readingType" style="height: 38px; border-color: lightgray; color: black;"/>
                            <datalist id="vSensorReadingTypes">
                                <option [value]="j.type" *ngFor="let j of sensorReadingTypes">{{j.type}}</option>
                            </datalist>
                        </div>
            
                        <div class="form-group">
                            <label *ngIf="i==0" for="{{'testButton' + i}}" style="font-weight: 500; margin-bottom: 2px;">Test</label>
                            <div>
                                <button (click)="testVirtualSensorFunctionWithValues(i)" style="height: 38px;" id="{{'testButton' + i}}" name="{{'testButton' + i}}" class="btn btn-primary" type="button">Evaluate</button>
                            </div>
                        </div>

                        <div class="form-group" style="width: 100px;">
                            <label *ngIf="i==0" for="{{'VSensorResults' + i}}" style="font-weight: 500; margin-bottom: 2px;">Result</label>
                            <div style="display: flex; gap: 10px;">
                                <input [(ngModel)]="function.testResults" style="color: black;" class="form-control" id="{{'VSensorResults' + i}}" name="{{'VSensorResults' + i}}" disabled=true required type="text" />
                                <i *ngIf="waitForFunctionTest && function.testResults == 'testing'" class="fa fa-spinner fa-spin fa-2x fa-fw"></i>
                            </div>
                        </div>

                        <div style="width: 40px; color: #5279bc; margin-top: 7px;">
                            <label *ngIf="i==0" for="{{'AddVirtualFunction' + i}}"><br></label>
                            <div *ngIf="!lastel" class="text-left">
                              <div class="far fa-trash-alt" style="color:#c8102e; cursor: pointer; font-size: 14px;" aria-hidden="true " (click)="delVirtualFunction(i) "></div>
                            </div>
                            <div *ngIf="lastel" class="text-left">
                              <span class="far fa-trash-alt" style="color:#c8102e; cursor: pointer; font-size: 14px;" aria-hidden="true " (click)="delVirtualFunction(i) "></span>
                              <span class="fas fa-plus pull-right" style="font-size: 18px; margin-top: 1px" aria-hidden="true " (click)="addVirtualFunction()"></span>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="virtualSensor.functions == undefined || virtualSensor.functions.length==0">
                    <div class="fas fa-plus" aria-hidden="true " (click)="addVirtualFunction()"></div>
                    <span class="sr-only">Plus</span>
                </div>

            </div>
        </div>

        <div class="card" style="margin-bottom: 20px; font-size: 15px;">
            <div style="background-color: #203864; color: white; font-size: 16px; padding-left: 10px; padding-top: 3px; height: 30px;">
                Existing Sensors - Assign Variables to Reference in Virtual Functions
            </div>
            <div class="card-body" style="padding: 0px;">
                <p-table #sensorsForVirtualTable [columns]="sensorsForVirtualCols" [value]="virtualSensor.parameters" [scrollable]="true" scrollHeight="15em">
                    <ng-template pTemplate="caption">
                        <div style="text-align: left; display: flex; gap: 1em; align-items: center;">
                            <i class="fa fa-search"></i>
                            <form (ngSubmit)="searchSensorsForVirtual()">
                                <input [(ngModel)]="searchSensorForVirtualText" style="width: 250px;" class="form-control" id="sensorSearch" name="sensorSearch" required type="text" />
                            </form>
                            <button (click)="searchSensorsForVirtual()" style="height: 35px; padding-top: 4px;" class="btn btn-primary" type="button">Search</button>
                            <i *ngIf="waitForSensorSearch" class="fa fa-spinner fa-spin fa-2x fa-fw"></i>
                            <div style="padding: 2px; margin-left: 60px; font-weight: 400;">
                                <label>Note: Use last X - Use last x minutes of readings, 0=Use last reading (interpolated)</label>
                                <label style="margin-left: 40px;">Aggr - Combine last x readings using aggregation method</label>
                            </div>
                        </div>
                    </ng-template>
                    <ng-template let-columns pTemplate="header">
                        <tr>
                            <th *ngFor="let col of columns" [ngStyle]="{'width': col.width}" style="background-color: var(--kig-section-header-bg); flex: none; height: 35px;">
                                {{col.header}}
                            </th>
                        </tr>
                    </ng-template>
                    <ng-template let-columns="columns" let-rowData let-rowIndex="rowIndex" pTemplate="body">
                        <tr style="height: 35px;">
                            <td pEditableColumn [ngStyle]="{'width': columns[0].width}" style="flex: none; border-width: 0px; vertical-align: middle;" >
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input #pInputTextVirtualSensorRef type="text" maxlength="15" (focusout)="virtualSensorParametersChanged(rowData)" [(ngModel)]="rowData.name" id="rowData.id" name="rowData.id" style="width: 120px; margin-left: -10px;" >
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        <label style="border: 1px dotted lightgray; width: 100%; margin-left: 0px; height: 30px; padding: 6px;"> {{ rowData.name }}</label>
                                    </ng-template>
                                </p-cellEditor>
                            </td>

                            <td [ngStyle]="{'width': columns[1].width}" style="flex: none; border-width: 0px; vertical-align: middle;">
                                {{ rowData.sensorName }}
                            </td>

                            <td pEditableColumn [ngStyle]="{'width': columns[2].width}" style="flex: none; border-width: 0px; vertical-align: middle;" >
                                <div style="display: flex; gap: 5px;">
                                    <p-cellEditor>
                                        <ng-template pTemplate="input">
                                            <input #pInputSampleNMinus type="number" min="0" [(ngModel)]="rowData.useLastXReadings" id="nMinus + rowData.id" name="nMinus + rowData.id" style="width: 80px; margin-left: -10px;" >
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            <label style="border: 1px dotted lightgray; width: 60px;  height: 30px; padding: 6px; text-align: center;"> {{ rowData.useLastXReadings }}</label>
                                        </ng-template>
                                    </p-cellEditor>

                                    <input type="text" name="{{'useLastXMathOption' + i}}" list="useLastXMathOptions" class="form-control" [(ngModel)]="rowData.useLastXAggr" style="height: 30px; width: 60px; border-color: lightgray; color: black;"/>
                                    <datalist id="useLastXMathOptions">
                                        <option [value]="useLastXMathOption" *ngFor="let useLastXMathOption of useLastXMathOptions">{{useLastXMathOption}}</option>
                                    </datalist>
                                </div>
                            </td>

                            <td [ngStyle]="{'width': columns[3].width}" style="flex: none; border-width: 0px; vertical-align: middle;">
                                {{ rowData.readingType }}
                            </td>

                            <td pEditableColumn [ngStyle]="{'width': columns[4].width}" style="flex: none; border-width: 0px; vertical-align: middle;" >
                                <div style="display: flex; align-items: center; gap: 6px;">
                                    <!-- Fills the box with the current value, using this row's Use Last X & Aggr. -->
                                    <i *ngIf="!calculatingTestValueFor.has(rowData)" class="fa fa-calculator" role="button" tabindex="0"
                                       style="color: #5279bc; cursor: pointer; font-size: 15px;"
                                       [title]="calculateTestValueTitle(rowData)" [attr.aria-label]="calculateTestValueTitle(rowData)"
                                       (click)="calculateTestValue($event, rowData)" (keydown.enter)="calculateTestValue($event, rowData)"></i>
                                    <i *ngIf="calculatingTestValueFor.has(rowData)" class="fa fa-spinner fa-spin" style="color: #5279bc; font-size: 15px;" title="Calculating ..."></i>

                                    <p-cellEditor style="flex: 1 1 auto; min-width: 0;">
                                        <ng-template pTemplate="input">
                                            <input #pInputTextVirtualTestValue type="text" maxlength="10" [(ngModel)]="rowData.testValue" id="rowData.sensorName" name="rowData.sensorName" style="width: 80px;" >
                                        </ng-template>
                                        <ng-template pTemplate="output">
                                            <label style="border: 1px dotted lightgray; width: 100%; height: 26px; padding: 6px;"> {{ rowData.testValue }}</label>
                                        </ng-template>
                                    </p-cellEditor>
                                </div>
                            </td>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="emptymessage">
                        No search results. Try again.
                    </ng-template>
                </p-table>
            </div>
        </div>

        <button *ngIf="sensor.id > 0 " (click)="getDateRangesForNewOrDelete(SelectDatesTemplate, 'new')" class="btn btn-primary btn-sm" style="margin-right: 10px;" type="button">Generate Readings for 
            Virtual Sensor
        </button>
        <!-- <button (click)="bsModalRef.hide()" class="btn btn-success" style="float: right; margin-bottom: 20px;" type="button">Close</button>
    </div>
</div> -->


<ng-template #SelectDatesTemplate>
    <div cdkDrag [cdkDragDisabled]="!modalDragOn" cdkDragRootElement=".modal-content" class="selectDates-modal virtual-generate-modal">
        <div style="background-color: #548235;  height: 7px;"></div>
        <div class="modal-header" (mouseenter)="setDragOn(true)" (mouseleave)="setDragOn(false)" style="background-color:#a9d18e; height: 50px; padding-top: 20px; border-radius: 0px;">     
            <h5 style="color: rgb(10, 10, 10); text-transform: none;">{{dataRangeSelectorTitle}}</h5>
            <button
            (click)="dateRangeSelectorRef.hide()"
            class="ms-auto fas fa-times"pe="button"
            style="background-color: transparent; border: transparent; font-size: 16px; margin-top: -4px;;">
            </button>
        </div>
  
        <div class="modal-body">
            <div style="display: flex; gap: 25px; align-items: center;">
                <label>UTC</label>
                <div class="form-group" style="margin-top: 10px; margin-bottom: 10px;">
                    <input (datesUpdated)="datesUpdated()" [(ngModel)]="selectedDateRange" [alwaysShowCalendars]="true" [isInvalidDate]="isInvalidDate"
                        [linkedCalendars]="true" [ranges]="ranges" [showClearButton]="true" [showCustomRangeLabel]="true" autocomplete="off"
                        ngxDaterangepickerMd placeholder="Select Date Range" type="text" style="width:220px; height: 35px; font-size: medium;" />
                </div>
                <div *ngIf="selectedDateRange.startDate != undefined && selectedDateRange.endDate != undefined">
                    <button (click)="ProcessNewOrDelete()" class="btn btn-success">{{ collectingDateRangeFor == 'new' ? 'Generate Readings' : 'Continue' }}</button>
                </div>
                <div *ngIf="processingVirtualSensorReadings" style="margin-top: 5px; font-size: 12px;">
                    <i class="fa fa-spinner fa-spin fa-3x fa-fw"></i>
                </div>
                <div *ngIf="!processingVirtualSensorReadings" style="margin-top: 5px; flex: 1 1 0; min-width: 0;"
                     [style.font-size.px]="(generateResult?.missing ?? 0) > 0 ? 14 : 16">
                    {{ processingVirtualSensorReadingsResults }}
                </div>
            </div>

            <!-- Generate mode only: show the readings behind each calculated value. A display toggle, so it
                 works on the result already on screen without running the calculation again. -->
            <label *ngIf="collectingDateRangeFor == 'new'" class="virtual-generate-sources-toggle">
                <input type="checkbox" [(ngModel)]="showSourceReadings" [ngModelOptions]="{standalone: true}" />
                Show source readings for calculated values
            </label>

            <div *ngIf="collectingDateRangeFor == 'new' && generateResult != null" class="virtual-generate-results">
                <div *ngIf="generateResult.rowsTruncated" class="virtual-generate-notice">
                    Showing the first {{ generateResultRows.length | number }} timestamps ({{ generateResult.created | number }} readings were created in total).
                </div>
                <div *ngIf="generateResult.sourcesOmitted && showSourceReadings" class="virtual-generate-notice">
                    Some source readings are not shown because there are too many. Use a shorter date range to see them all.
                </div>

                <div class="virtual-generate-scroll">
                    <table class="virtual-generate-table">
                        <thead>
                            <tr>
                                <th class="col-time">Timestamp</th>
                                <th class="col-type">Reading Type</th>
                                <th class="col-value">Value</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let row of generateResultRows; trackBy: trackByRow">
                                <tr [class.row-created]="row.status == 'created'" [class.row-skipped]="row.status != 'created'">
                                    <td class="col-time">{{ row.timestamp | date: 'MM/dd/yyyy HH:mm' }}</td>
                                    <td class="col-type">{{ row.readingType }}</td>
                                    <td class="col-value">
                                        <ng-container *ngIf="row.status == 'created'">{{ row.value | number: '1.0-6' }}</ng-container>
                                        <ng-container *ngIf="row.status != 'created'">
                                            <span *ngIf="row.value != null">{{ row.value | number: '1.0-6' }}&nbsp;</span>
                                            <span class="skipped-detail">({{ row.detail }})</span>
                                        </ng-container>
                                    </td>
                                </tr>

                                <ng-container *ngIf="showSourceReadings && row.status == 'created'">
                                    <tr *ngFor="let source of sourcesOf(row)" class="row-source">
                                        <td class="col-time">{{ source.timestamp | date: 'MM/dd/yyyy HH:mm' }}</td>
                                        <td class="col-type">{{ source.variable }}: {{ source.sensorName }} | {{ source.readingType }}</td>
                                        <td class="col-value">{{ source.value | number: '1.0-6' }}</td>
                                    </tr>
                                </ng-container>
                            </ng-container>

                            <tr *ngIf="generateResultRows.length == 0">
                                <td colspan="3" class="virtual-generate-empty">No timestamps in this date range.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</ng-template>